import {
  ApiError,
  requestJson,
} from '../../../shared/api/apiClient';

const LOGIN_ENDPOINT =
  process.env.REACT_APP_LOGIN_ENDPOINT || '/api/auth/login';

const LOGOUT_ENDPOINT =
  process.env.REACT_APP_LOGOUT_ENDPOINT || '/api/auth/logout';

const ME_ENDPOINT =
  process.env.REACT_APP_ME_ENDPOINT || '/api/auth/me';

const LOGIN_ERROR_CODE_MAP = Object.freeze({
  INVALID_CREDENTIALS: 'errors.invalidCredentials',
  ACCOUNT_DISABLED: 'errors.accountDisabled',
  ACCOUNT_LOCKED: 'errors.accountLocked',
  LOGIN_FORBIDDEN: 'errors.forbidden',
  TOO_MANY_REQUESTS: 'errors.tooManyRequests',
});

export async function login({ userId, password }) {
  const normalizedUserId = String(userId || '').trim();
  const normalizedPassword = String(password || '');

  if (!normalizedUserId || !normalizedPassword) {
    throw new ApiError('Invalid login input', {
      status: 400,
      code: 'INVALID_LOGIN_INPUT',
    });
  }

  return requestJson(
    LOGIN_ENDPOINT,
    {
      method: 'POST',
      body: JSON.stringify({
        userId: normalizedUserId,
        password: normalizedPassword,
      }),
    },
    {
      skipUnauthorizedHandler: true,
    },
  );
}

export async function logout() {
  return requestJson(
    LOGOUT_ENDPOINT,
    {
      method: 'POST',
    },
    {
      skipUnauthorizedHandler: true,
    },
  );
}

export async function getCurrentUser() {
  try {
    const response = await requestJson(ME_ENDPOINT, {
      method: 'GET',
    }, {
      skipUnauthorizedHandler: true,
    });

    return (
      response?.user ||
      response?.data?.user ||
      response ||
      null
    );
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      return null;
    }

    throw error;
  }
}

export function getLoginErrorDescriptor(error) {
  if (!(error instanceof ApiError)) {
    return {
      key: 'errors.unknown',
      field: null,
    };
  }

  const mappedErrorKey =
    LOGIN_ERROR_CODE_MAP[error.code];

  if (mappedErrorKey) {
    return {
      key: mappedErrorKey,
      field: null,
    };
  }

  if (error.code === 'REQUEST_TIMEOUT') {
    return {
      key: 'errors.requestTimeout',
      field: null,
    };
  }

  if (error.code === 'NETWORK_ERROR') {
    return {
      key: 'errors.network',
      field: null,
    };
  }

  if (error.status === 401) {
    return {
      key: 'errors.invalidCredentials',
      field: null,
    };
  }

  if (error.status === 403) {
    return {
      key: 'errors.forbidden',
      field: null,
    };
  }

  if (error.status === 429) {
    return {
      key: 'errors.tooManyRequests',
      field: null,
    };
  }

  if (error.status >= 500) {
    return {
      key: 'errors.server',
      field: null,
    };
  }

  return {
    key: 'errors.requestFailed',
    field: null,
  };
}
